export default "__VITE_ASSET__1ibAEirC__"